import { render, staticRenderFns } from "./textareaGroup.vue?vue&type=template&id=4beb0469&"
import script from "./textareaGroup.vue?vue&type=script&lang=js&"
export * from "./textareaGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports